import {AbstractModel} from './abstract-model';

export class TrafficSource extends AbstractModel {
  id: number | null = null;
  key: string | null = null;
  name: string | null = null;
}
